import { CONSENT_KEY, DISMISSED_KEY, Consent } from '../types';

export function persistConsent(value: Exclude<Consent, null>): boolean {
  try {
    localStorage.setItem(CONSENT_KEY, value);
    return true;
  } catch {
    return false;
  }
}

export function readConsent(): Consent {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function isBannerDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) !== null;
  } catch {
    return false;
  }
}

export function persistBannerDismissal(): void {
  try {
    localStorage.setItem(DISMISSED_KEY, String(Date.now()));
  } catch {}
}
